/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { AlertCircleOutline } from 'react-ionicons';
import ListItem from '../component/Inputs/ListItems/ListItem';
import { PageContainer, PageContent } from '../component/Containers/Containers';
import { useDispatch, useSelector } from 'react-redux';
import { setIsLoadingTo, setLoginStatus } from '../store/features/adminSlice';
import {
  compareAndUpdateFavorites,
  compareAndUpdateRecents,
  filterRecents,
  getStations,
  setFavorites,
  setIsFirstLoad,
  setProvince,
  setRecentsTo,
  setStationsTo,
  stopAllRecentsPlaying,
} from '../store/features/stationSlice';
import * as localForage from 'localforage';
import { setFirstLoad, setPlayingToFalse } from '../store/features/playerSlice';
import { HttpListClient } from '../utils/HttpClient';
import Swal from 'sweetalert2';

/**
 * @component
 * returns the favorite view, only displays stations marked as favorite
 * @returns {void}
 */
const Favourites = () => {
  const dispatch = useDispatch();

  const {
    isSearching,
    filteredList,
    favouriteStations,
    allStations,
    activeStations,
  } = useSelector((state) => state.stations);

  const { isLoading } = useSelector((state) => state.admin);

  const [stations, setStations] = useState([]);

  const favouriteStorage = localForage.createInstance({
    name: 'favorites',
  });

  let recentStorage = localForage.createInstance({
    name: 'recent',
  });

  window.onbeforeunload = () => {
    dispatch(setFirstLoad(true));
    dispatch(setLoginStatus(false));
    dispatch(setPlayingToFalse());
    dispatch(filterRecents());
    dispatch(stopAllRecentsPlaying());
    dispatch(filterRecents());
  };

  window.onload = async () => {
    dispatch(setFirstLoad(true));
  };

  const getStationsFromApi = async () => {
    let res;
    try {
      let { data } = await HttpListClient.get('/getStations');
      let provinceData = await HttpListClient.get('/getProvinces');

      res = JSON.parse(atob(data)) ?? [];
      await dispatch(getStations(res));
      await dispatch(setProvince(provinceData.data));
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: 'Parece haber un problema con la conexion por favor intente mas tarde.',
        icon: 'warning',
        iconColor: '#FFD732',
        confirmButtonColor: '#003876',
      });
      await dispatch(getStations([]));
    }
    let recents = (await recentStorage.getItem('recents')) ?? [];
    dispatch(setRecentsTo(recents.filter((a) => typeof a != 'undefined')));
  };

  useEffect(async () => {
    dispatch(setIsLoadingTo(true));
    getStationsFromApi();
    dispatch(setIsFirstLoad(true));
    let favs = (await favouriteStorage.getItem('favs')) ?? [];
    dispatch(setFavorites(favs));
    dispatch(compareAndUpdateRecents());
    dispatch(compareAndUpdateFavorites());
    setTimeout(() => {
      dispatch(setIsLoadingTo(false));
    }, 500);
  }, []);

  useEffect(() => {
    let map = [];

    allStations.forEach((station) => {
      if (station.IsActive) {
        let newStation = Object.assign({}, station);
        map.push(newStation);
      }
    });

    let favs = [];

    favouriteStations.forEach((station) => {
      let newStation = Object.assign({}, station);
      favs.push(newStation);
    });

    map.forEach((stationA) => {
      favs.forEach((stationB) => {
        if (stationA.IsActive) {
          if (stationA.Id === stationB.Id) {
            if (!stationA.Favorite) {
              stationA.Favorite = true;
            }
          }
        }
      });
    });
    setStations(map);
  }, [favouriteStations, allStations]);

  useEffect(() => {
    let favs = [];
    favouriteStations.forEach((station) => {
      let newStation = Object.assign({}, station);
      favs.push(newStation);
    });
    let all = [];
    allStations.forEach((station) => {
      let newStation = Object.assign({}, station);
      all.push(newStation);
    });

    all.forEach((stationA) => {
      favs.forEach((stationB) => {
        if (stationA.Id === stationB.Id) {
          if (!stationA.Favorite) {
            stationA.Favorite = true;
          }
        }
      });
    });
    dispatch(setStationsTo(all));
  }, [favouriteStations, filteredList]);

  /**
   * @component
   * returns the text displayed when no favorites are available.
   * @returns {void}
   */
  const noFavouriteAvailable = () => (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '90%',
        color: '#003876',
        fontWeight: '400',
        top: '150px',
        fontFamily: " 'Montserrat', sans-serif !important",
      }}>
      <span style={{ paddingTop: '5px' }}>
        <AlertCircleOutline
          color={'#003876'}
          height="25px"
          width="25px"
          padding="5px"
          styled={{
            display: 'block !important',
            marginLeft: 'auto',
            marginRight: '10px',
          }}
        />
      </span>

      <h3 style={{ display: 'inline-block', marginLeft: '5px' }}>
        No ha seleccionado ninguna emisora favorita.
      </h3>
    </div>
  );

  /**
   * @component
   *returns the text displayed when searching and no matches are found
   * @returns {void}
   */
  const noFilteredAvailable = () => (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        color: '#003876',
        fontWeight: '400',
        top: '150px',
        fontFamily: " 'Montserrat', sans-serif !important",
      }}>
      <span style={{ paddingTop: '5px' }}>
        <AlertCircleOutline
          color={'#003876'}
          height="25px"
          width="25px"
          padding="5px"
          styled={{
            display: 'block !important',
            marginLeft: 'auto',
            marginRight: '10px',
          }}
        />
      </span>
      <h3 style={{ display: 'inline-block', marginLeft: '5px' }}>
        Ninguna estación disponible concuerda con su búsqueda.
      </h3>
    </div>
  );

  /**
   * @component
   *  returns the filtered stations rendered inside list Items
   * @returns {void}
   */
  const displayFilteredStations = () =>
    filteredList.length > 0 &&
    filteredList
      .filter((station) => station.IsActive)
      .sort((a, b) => a.Name.toString().localeCompare(b.Name))
      .map((station, index) =>
        station.IsActive ? (
          <React.Fragment key={station.Id}>
            <ListItem station={station} />
          </React.Fragment>
        ) : (
          noFilteredAvailable()
        ),
      );

  return (
    <PageContainer>
      {isLoading ? null : isSearching && !filteredList.length > 0 ? (
        noFilteredAvailable()
      ) : isSearching ? (
        <PageContent>
          {displayFilteredStations().length > 0
            ? displayFilteredStations()
            : noFilteredAvailable()}
        </PageContent>
      ) : favouriteStations.length ? (
        <PageContent>
          {stations.filter((station) => station.IsActive && station.Favorite)
            .length > 0
            ? stations
                .filter((station) => station.IsActive && station.Favorite)
                .sort((a, b) => a.Name?.toString().localeCompare(b.Name))
                .map((station, index) => (
                  <React.Fragment key={index}>
                    <ListItem station={station} />
                  </React.Fragment>
                ))
            : noFavouriteAvailable()}
        </PageContent>
      ) : (
        noFavouriteAvailable()
      )}
    </PageContainer>
  );
};

export default Favourites;
